import React from "react";
import { Badge } from "@/components/ui/badge";
import { Users } from "lucide-react";

interface ChannelGibletBadgeProps {
  className?: string;
}

const ChannelGibletBadge: React.FC<ChannelGibletBadgeProps> = ({ className = "" }) => {
  return (
    <Badge 
      className={`bg-gradient-to-r from-teal-500 via-cyan-400 to-teal-600 text-white border-teal-700 font-semibold shadow-sm ${className}`}
    >
      <Users className="h-3 w-3 mr-1" />
      Channel
    </Badge>
  );
};

export default ChannelGibletBadge;
